import { Box } from '@mui/material';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';

const Layout: FC = () => {
  return (
    <Box display="flex" flexDirection="column" height="100vh">
      <Header />
      <Box width={"100%"} display={'flex'} justifyContent={'center'} flex={1}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
